import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getCoaches, updateCoachProfile } from '@/lib/api-calls.js';
import { FullCoach } from '@airreading/common/data';
import { Checkbox } from '@/components/ui/checkbox.js';

export interface NeedsReviewToggleProps {
  coach: FullCoach;
}

export const NeedsReviewToggle = ({ coach }: NeedsReviewToggleProps) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: updateCoachProfile,
    onSuccess: () => {
      queryClient.invalidateQueries(getCoaches());
    },
  });

  const handleCheckedChange = (checked: boolean | 'indeterminate') => {
    mutate({ userId: coach.id, data: { needsReview: Boolean(checked) } });
  };

  return <Checkbox checked={Boolean(coach.needsReview)} disabled={isPending} onCheckedChange={handleCheckedChange} />;
};
